export const ENDPOINTS = {
  PROVIDER_TIN_SEARCH: '/provider-tin-search',
  PROVIDER_SEARCH: '/provider-search',
  CONTRACT_SEARCH: '/contract-search',
  EXTENDED_TINS_SEARCH: '/extended-tins/search',
  FETCH_USER_SAVED_TINS: '/fetchAllGroups',
  GEO_SEGMENTATION_SEARCH: '/geo-segmentation/search',
  SAVE_SEARCH_DETAILS: '/save-search-details',
  SAVE_CONTRACT_SEARCH_DETAILS: '/save-contract-search-details',
  SAVE_TINS_GROUP: '/saveGroup',
  SAVE_GEO_SEARCH_DETAILS: '/save-geo-search-details',
  PSMS_SAVE_GEO_SEARCH_DETAILS: '/psms-save-geo-search-details',
  PSMS_PROVIDER_TIN_SEARCH: '/extended-tins/psmssearch',
  PSMS_ENTITY_TIN_SEARCH: '/psms-entity-tin-search',
  PSMS_SAVE_SEARCH_DETAILS: '/psms-save-search-details',
  PSMS_PROVIDER_SEARCH: 'psms-provider-search?search-type=hco',
};

export const QUERY = {
  SEARCH_TYPE: 'search-type',
  LIMIT: 'limit',
  PAGE: 'page',
  SEARCH_VALUE_PROVIDER: 'SearchValue',
  SEARCH_VALUE_TIN: 'SearchValue',
  SEARCH_VALUE_GEO: 'searchValue',
  USER_ID: 'userId',
};
